import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationET from './locales/et/translation.json';
import translationEN from './locales/en/translation.json';

const timezoneDetector = {
  name: 'timezone',
  lookup() {
    try {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (timeZone === 'Europe/Tallinn') {
        return 'et';
      }
    } catch (e) {
        console.error('Timezone detection error:', e);
    }
    return undefined;
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(timezoneDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      et: { translation: translationET },
      en: { translation: translationEN }
    },
    supportedLngs: ['et', 'en'],
    fallbackLng: "en",
    
    detection: {
      order: ['querystring', 'localStorage', 'timezone', 'navigator'],
      caches: ['localStorage'], 
    },

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
